// Pure initial-state factory. NOT persisted anywhere client-side. The backend
// (Supabase) is the source of truth — see /api/registrations/{app_no}.

export const initialState = () => ({
  applicationNumber: "",
  qid: null,
  mobile: "",
  otpVerified: false,
  candidate: {
    name: "",
    photo: null,
    accuracyConfirmed: false,
    nationality: "",
    affidavitRef: "",
    dateOfBirth: "",
    educationBoard: "",
    gender: "",
    bloodGroup: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    parent1Name: "",
    parent1Phone: "",
    parent1Relation: "",
    parent1Email: "",
    parent2Name: "",
    parent2Phone: "",
    parent2Relation: "",
    parent2Email: "",
    emergencyContactName: "",
    emergencyContactPhone: "",
    emergencyContactRelation: "",
    isFromHyderabad: null,
    isHosteller: null,
  },
  documents: {},
  policies: {},
  policiesFilled: {},
  undertaking: { confirmed: false, signedAt: null },
  submitted: false,
  status: "draft",
  ackNumber: "",
  submittedAt: null,
  assignedSlot: null,
  step: 1,
  docStatuses: {},
  emailVerified: {},
  phoneVerified: {},
  courseInfo: {},
  skipPolicies: false,
  originalReceived: {},
  lastActionReason: null,
  history: [],
});

export const genAckNumber = () => {
  const rand = Math.floor(100000 + Math.random() * 900000);
  return `MU-BBA-2026-${rand}`;
};
